import React, { Component } from 'react';
import Switch from '../../../../Part_Sample/Switch';
import { isEmpty } from '../../../../Common/Common';

export default class RC_Proh_Mode extends Component {
	constructor(props) {
		super(props);
		let is_enabled = false;
		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.rmode_proh) is_enabled = true;
		}

		this.state = {
			is_enabled: is_enabled,
		}
	}

	handleToggleRCProhMode = () => {
		let is_enabled = !this.state.is_enabled;
		this.setState({ is_enabled: is_enabled })

		this.props.handleToggleRCProhMode(is_enabled);
	}

	render() {
		return (
			<div id='rmode_proh' style={this.props.style}>
				<div style={{ padding: 10, }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleRCProhMode} />
					<div style={{ display: 'inline-block', marginLeft: 10, verticalAlign: 'top', paddingTop: 5 }}>
						<span> {this.props.receiver.getString('rmode_proh')} </span>
					</div>
				</div>
			</div>
		)
	}
}